import React, { useContext, useEffect } from "react";
import { PciSdkTypes, PCI_IFRAME_IDS } from "PCI/utills";
import { get } from "logics/src/utils/helpers";

import {
  ListenMessage,
  LISTEN_MESSAGE_TYPE,
  PostMessage,
  POST_MESSAGE_TYPE,
} from "services/MessageService";
import { ExpressSavedPciContainer } from "PCI/assets/style";
import { PAYMENT_MODES } from "constants/paymentModes";
import { ExpressCheckoutContext } from "wrapper/ExpressCheckoutWrapper/context/expressCheckoutContext";
import PCI from "PCI";
import { trackExpressCheckoutEnterCvv } from "layouts/ExpressCheckoutPayment/dependencies/helpers/tracking";
import { toLowerCase } from "logics/src/utils/toLowerCase";

const ExpressSavedCard = ({ paymentContext, pciPageLoadData, doPayment, setLoading }: any) => {

  const expressContext = useContext(ExpressCheckoutContext);
  const setPciOtpInfo = get(expressContext, "setPciOtpInfo");
  const showOtpScreen = get(expressContext, "showOtpScreen");
  const setShowOtpScreen = get(expressContext, "setShowOtpScreen");
  const setHoldOrderCreate = get(expressContext, "setHoldOrderCreate");
  const mode = toLowerCase(pciPageLoadData?.paymentInfo?.recommendedPaymentDetails?.mode) || "";
  const isCvvLessEligible =
    pciPageLoadData?.paymentInfo?.recommendedPaymentDetails?.cvvLessEligible || false;

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_LOAD_OTP_EXPRESS_SAVED, res => {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.LOAD,
          data: pciPageLoadData,
        },
        PCI_IFRAME_IDS.EXPRESS_SAVED
      );
    });

    PostMessage(
      {
        messageEventName: POST_MESSAGE_TYPE.RELOAD,
        data: pciPageLoadData,
      },
      PCI_IFRAME_IDS.EXPRESS_SAVED
    );

    ListenMessage(LISTEN_MESSAGE_TYPE.ERROR_MESSAGE, res => {
      setLoading(false);
    });
    
    if (
      (mode === PAYMENT_MODES.CREDIT_CARD || mode === PAYMENT_MODES.DEBIT_CARD) &&
      !pciPageLoadData?.paymentInfo?.recommendedPaymentDetails?.cvvLessEligible
    ) {
      trackExpressCheckoutEnterCvv();
    }

  }, [pciPageLoadData?.paymentInfo?.paymentAmount]);

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.CREATE_ORDER_EXPRESS_SAVED, orderParams => {
      doPayment(PAYMENT_MODES.SAVED_CARD, {
        ...orderParams?.values,
        cvvLessEligible: isCvvLessEligible,
      });
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_PAYMENT_EXPRESS_SAVED_CARD, res => {
      setPciOtpInfo(res);
      setShowOtpScreen(true);
      setHoldOrderCreate(false);
    });
  });

  return (
    <>
      {showOtpScreen ? (
        <PCI paymentContext={paymentContext} sdkType={PciSdkTypes.OTP} setLoading={setLoading} />
      ) : (
        <ExpressSavedPciContainer
          id={PCI_IFRAME_IDS.EXPRESS_SAVED}
          sandbox="allow-scripts allow-forms allow-top-navigation allow-same-origin allow-orientation-lock allow-pointer-locks"
          src={`${process.env.PCI_ORIGIN}/expressSaved`}
          height={'100%'}
        />
      )}
    </>
  );
};

export default ExpressSavedCard;
